import React from 'react';
import {Container} from 'react-bootstrap';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    Link
  } from "react-router-dom";
import CarrerasPage from '../pages/CarrerasPage';
import GaleriasPage from '../pages/GaleriasPage';
import HomePage from '../pages/HomePage';
import InstitucionalPage from '../pages/InstitucionalPage';
import BarraSuperior from '../components/BarraSuperior';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import ConsultasPage from '../pages/ConsultasPage';
import CarreraDetalle from '../pages/CarreraDetalle';
import PoliticaPrivacidadPage from '../pages/PoliticaPrivacidadPage';

const AppRouter = () => {
    return (
        <Router>
            <Menu />
            <BarraSuperior />
            <Container>      
            <Switch>
                <Route exact path="/" component={HomePage} />                    
                <Route path="/institucional" component={InstitucionalPage} />                    
                <Route path="/galeria" component={GaleriasPage} />
                <Route path="/carreras" component={CarrerasPage} />
                <Route path="/consultas" component={ConsultasPage} />

                {/* Compatibilidad con links/bookmarks viejos */}
                <Redirect exact from="/carrera_desarrollo_ia" to="/carrera/carrera_desarrollo_ia" />
                <Redirect exact from="/carrera_desarrollo" to="/carrera/carrera_desarrollo" />
                <Redirect exact from="/carrera_bromatologia" to="/carrera/carrera_bromatologia" />
                <Redirect exact from="/carrera_energias" to="/carrera/carrera_energias" />
                <Redirect exact from="/carrera_administracion" to="/carrera/carrera_administracion" />
                <Redirect exact from="/carrera_contable" to="/carrera/carrera_contable" />

                {/* Ruta dinámica única: sirve para cualquier carrera que exista en carreras.json */}
                <Route path="/carrera/:slug" component={CarreraDetalle} />

                <Route path="/politica_privacidad" component={PoliticaPrivacidadPage} />  
            </Switch>
            </Container>    
    <Footer/>
        </Router>
    )
}

export default AppRouter